module.exports = __webpack_public_path__ + "img/Hose.b4b5bd47.jpeg";